import { API_PREFIX } from '@debtbot/shared';
import { ApiError, NetworkError } from './errors';

let rawInitData = '';
let reloading = false;

export function configureApi(initData: string): void {
  rawInitData = initData;
}

const BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? API_PREFIX;

type RequestOptions = { method?: 'GET' | 'POST' | 'PATCH' | 'DELETE'; body?: unknown };

/**
 * fetch-обёртка: заголовок `Authorization: tma <initData>`, JSON, единый разбор ошибок.
 * 401 означает истёкший initData — перезагружаем Mini App, Telegram выдаст свежий (E19).
 */
export async function api<T>(
  path: string,
  { method = 'GET', body }: RequestOptions = {},
): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${BASE}${path}`, {
      method,
      headers: {
        Authorization: `tma ${rawInitData}`,
        ...(body !== undefined && { 'Content-Type': 'application/json' }),
      },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new NetworkError();
  }

  if (res.status === 204) return undefined as T;

  const json: unknown = await res.json().catch(() => null);
  if (!res.ok) {
    if (res.status === 401 && !reloading && rawInitData) {
      reloading = true;
      window.location.reload();
    }
    throw ApiError.fromBody(res.status, json);
  }
  return json as T;
}
